module.exports = "/_next/static/media/a7ce5f1be7c3e1ebce36dd8c25936400.svg";